<template>
  <div>
    <DxForm
      :form-data="formData"
      :items="items"
      :label-location="labelLocation"
    >
      <template #form-line-item="{ data: item }">
        <div>
          {{ formData[item.dataField] }}

          <LineItem v-model="formData[item.dataField]" :fname="item.dataField" :modRoute="routeDef" />
        </div>
      </template>
      <!-- relate field -->
      <template #form-rlt="{ data: item }">
        <div>
          
          <DropDataGrid
            v-model="formData[item.dataField]"
            :rRoute="item.editorOptions.relateModule"
            :slug='slug'
          >
          </DropDataGrid>
        </div>
      </template>
      <!-- checkbox grup -->
      <template #form-checkbox-group="{data: item}">
        <CheckboxGroup v-model="formData[item.dataField]" :checkList ="item" >
        </CheckboxGroup>        
      </template>


        <template #cstm_field="{ data: item }">
          <div>
           
              <custom-field-types 
              :item = item 
              :prefix="slug"
              :routeDef = routeDef
              v-model="formData[item.dataField]">
              </custom-field-types>
          </div>
      </template>

    

     
      <template #form-invoice-item="{data:{dataField,editorOptions}}">
        
          <InvFieldType 
            v-model="formData[dataField]"
            :fname="dataField"
            :modRoute="routeDef"
            :slug="slug"
            :def="editorOptions"
            :partyLedgerId="formData['cnsl_ledger_id']"
             />
      </template>


      
      <template #form-trn="{ data: item }">
        <div>
          <transaction
            v-model="formData[item.dataField]"
            :rRoute="item.editorOptions.relateModule"
            :rltName ="item.editorOptions.rltName"
            @transaction_selection="handleTransaction"
            :slug="slug">

          </transaction>
        </div>
      </template>

     
      <template #morph-rlt="{ data: item }">
        <div>
          <MorphField
            :prefix="slug"
            v-model="formData[item.dataField]"
            :rRoute="item.editorOptions.relateModule"
            :fname="item.editorOptions.rltName"
          >
          </MorphField>
        </div>
      </template>
      <!-- textbox with listener -->
      <template #form-textbox="{ data: item }">
        <div>
          <DxTextBox
            v-model="formData[item.dataField]"
            :fname="item.dataField"
          />
        </div>
      </template>





    </DxForm>
  </div>
</template>

<script>
import { DxForm } from "devextreme-vue/form";

import DropDataGrid from "@/components/DropDataGrid.vue";
import DxTextArea from "devextreme-vue/text-area";
import RelateTemp from "@/Layouts/RelateFieldTemplate.vue";
import LineItem from "@/components/LineItemCompo.vue"
import CheckboxGroup from "@/components/CstmCheckboxGroup.vue"
import { getQuickCreateDef } from "@include/utils/GridUtils.js";
import CustomFieldTypes from "@/components/CustomFieldTypes.vue";
import InvoiceField from "@/components/InvoiceFieldCompo.vue";
//import MorphField from "@/components/MorphField.vue";
//import Transaction from "@/components/TransactionComponent.vue";


export default {
  props: {
    createDef: Array,
    routeDef: String,
    slug:String,
    modelData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    DxForm,
    LineItem,
    DropDataGrid,
    CheckboxGroup,
    CustomFieldTypes,
    InvoiceField,
   
    
  },
  data: function () {
    return {
      mode:"create",
      formData: this.modelData,
      labelLocation: "top",
      log : console.log,
      items: this.createDef,
    };
  },

  methods: {
    setData(data,mode)
    {
      this.mode = mode;
      this.formData = data;
    },
    
  },
  created: function () {
    
  },
  mounted() {

    
    /* def for quickcreate */
    getQuickCreateDef(this.routeDef,this.slug).then((response) => {
                 
        this.items = response.data.results;

        
    })
    .catch((error) => {  

    });
   
  },
};
</script>

<style>
.dx-form .dx-field-item-label {
  font-size: 12px;
  margin-bottom: 0px;
}
.createName{
  background-color: white !important; 
  margin-top: 10px;
  padding: 10px 30px;
}
.dx-form-group-caption {
  font-size: 14px;
  font-weight: bold;
  color: #535252;
}
</style>